import { render, staticRenderFns } from "./IndexBack.vue?vue&type=template&id=a90eac4c&scoped=true&"
import script from "./IndexBack.vue?vue&type=script&lang=js&"
export * from "./IndexBack.vue?vue&type=script&lang=js&"
import style0 from "./IndexBack.vue?vue&type=style&index=0&id=a90eac4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90eac4c",
  null
  
)

export default component.exports